<div class="password-container mx">
  <h3>{{'auth.changePassword' | translate}}</h3>
  <form #changePasswordForm="ngForm" (ngSubmit)="onSubmit(changePasswordForm)">
    <div class="form-field full-width pb mt-3" *ngIf="!isNewUser && isUserAccountValid">
      <p-floatlabel variant="on">
        <p-password name="oldPassword"
                    [(ngModel)]="userPasswordChangeDtoModel.oldPassword"
                    [toggleMask]='true'
                    id="oldPassword"
                    type="password"
                    class="full-width"
                    styleClass="full-width"
                    inputStyleClass="w-100"
                    required
                    customWhitespace="Password"
                    minlength="5"
                    maxlength="50"
                    formInlineError="auth.errors"
                    disableAutocomplete data-testid="old-password-password-input">
        </p-password>
        <label for="oldPassword" class="label">{{'auth.oldPassword' | translate}} *</label>
      </p-floatlabel>
    </div>

    <div class="form-field full-width pb" *ngIf="isNewUser || isUserAccountValid">
      <p-floatlabel variant="on">
        <p-password name="newPassword"
                    [(ngModel)]="userPasswordChangeDtoModel.newPassword"
                    [toggleMask]='true'
                    [promptLabel]="'auth.choosePassword' | translate"
                    [mediumRegex]='mediumPasswordRegex'
                    [strongRegex]='strongPasswordRegex'
                    [maxLength]='maximumPasswordLength'
                    [customPattern]='passwordRegex'
                    #pw="ngModel"
                    id="newPassword"
                    class="full-width"
                    styleClass="full-width"
                    inputStyleClass="w-100"
                    type="password"
                    required
                    formInlineError="auth.errors.password"
                    disableAutocomplete data-testid="new-password-password-input">
          <ng-template pTemplate='footer'>
              <auth-password-rules [password]='userPasswordChangeDtoModel.newPassword'>
              </auth-password-rules>
          </ng-template>
        </p-password>
        <label for="newPassword" class="label">{{'auth.password' | translate}} *</label>
      </p-floatlabel>
    </div>

    <div *ngIf="isNewUser || isUserAccountValid">
      <div class="form-field full-width pb">
        <p-floatlabel variant="on">
          <p-password name="confirmPassword"
                      [(ngModel)]="userPasswordChangeDtoModel.confirmPassword"
                      [toggleMask]='true'
                      [promptLabel]="'auth.choosePassword' | translate"
                      [mediumRegex]='mediumPasswordRegex'
                      [strongRegex]='strongPasswordRegex'
                      [maxLength]='maximumPasswordLength'
                      [customPattern]='passwordRegex'
                      id="confirmPassword"
                      #pwc="ngModel"
                      type="password"
                      required
                      formInlineError="auth.errors.password"
                      class="full-width"
                      styleClass="full-width"
                      inputStyleClass="w-100"
                      disableAutocomplete data-testid="confirm-password-password-input">
            <ng-template pTemplate='footer'>
              <auth-password-rules [password]='userPasswordChangeDtoModel.confirmPassword'>
              </auth-password-rules>
            </ng-template>
          </p-password>
          <label for="confirmPassword" class="label">{{'auth.passwordConfirmation' | translate}} *</label>
        </p-floatlabel>
      </div>
      <div class="form-field"
           *ngIf="(pwc.invalid || userPasswordChangeDtoModel.confirmPassword !== userPasswordChangeDtoModel.newPassword) && (pwc.dirty || pwc.touched)">
        <p class="color-danger"
           *ngIf="userPasswordChangeDtoModel.confirmPassword !== userPasswordChangeDtoModel.newPassword">
          {{'auth.errors.passwordConfirmation.passwordConfirmationMatchError' | translate}}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex mt-4 col-12 justify-content-end">
        <button type="submit" pButton [label]="'auth.changePassword' | translate" data-testid="change-password-btn"></button>
      </div>
    </div>
  </form>
</div>
